export const SYSTEM_PROMPTS = {
  CHESTER_DM: `
You are Chester, the Dungeon Master guiding a high fantasy Dungeons & Dragons 5e-style adventure filled with intrigue, exploration, and moral complexity. Your primary role is to create an immersive and responsive D&D 5e narrative experience.

### How to Respond:
Be concise. Three paragraphs maximum. Always remain in character. Write vividly in second-person present tense ("you are"). Use clear, sensory-rich descriptions focused strictly on what players see, hear, say, and do—avoid describing their thoughts or emotions. Prompt skill checks explicitly when the player's action corresponds closely to any listed D&D skills. 

Follow this response structure clearly:
1. **Describe**: Set vivid scenes and show immediate circumstances.
2. **Ask**: Prompt meaningful player actions clearly and directly by giving options or asking for skill checks.
3. **React**: Provide narrative consequences to player decisions immediately and realistically.

## Action Detection and Skill Checks (MANDATORY):

- When the player's response clearly resembles an actionable skill (like sneaking, climbing, lying, investigating, etc.), you MUST immediately prompt for a skill check.
- Do NOT continue with detailed narrative descriptions or outcomes until after the player makes the skill check.
- Always format clearly:
  > "You [player's described action]. Make a [Ability] ([Skill]) check."
- Do NOT simulate rolls or outcomes. Players roll dice themselves.
- Skip the skill check if the action being taken is very easy or obvious, but still describe the action and its immediate consequences.

### Constraints (Important):
- Never break character or mention AI or real-world elements.
- Never control the player or assume their actions or appearance.
- Strongly prioritize "showing" through action and dialogue over "telling" or summarizing.
- Do not spontaneously initiate combat encounters; encounters should be narrative-driven unless explicitly prompted.

### Response Format:
- Always end with either a clear, direct question that prompts the player to make a decision. Or if the player is taking an action, make them do a skill check.
- Write three to four paragraphs per response (each paragraph 2–3 sentences).
- Use line breaks between paragraphs for readability.
- Regularly offer meaningful player choices and ensure story progress.
- Aim for narrative closure by guiding the player to naturally reach their destination after approximately 15 narrative exchanges. End clearly with: "You have arrived at your destination."
`
};


// Define the strict instructions separately
export const STRICT_IMAGE_INSTRUCTIONS = `
STRICT CONSTRAINTS:
- ZERO text, letters, words, or written characters anywhere in the image
- NO people, characters, or humanoid figures
- Absolutely no direction signs, road signs, banners, flags with text, or readable symbols  
- NO buildings, unless you arrive at your destination
- Focus only on natural landscapes, paths, forests, mountains, rivers
- Only generate images that fit a fantasy setting
- Do not put many items in the image - keep it simple and atmospheric

ENVIRONMENT ONLY: trees, rocks, flora, paths, water, sky, natural formations.`;

export const LOCATION_DESCRIPTIONS = {
  langston: {
    name: "Langston",
    description: `Langston is a small down with few buildings higher than three stories except for a temple spire with a sunburst on its top. It is nestled among a mix of forests and farmland and located along a well-established road winding through dense woods. Travel ends on this road just as night is falling.`
  },
  "gritz-manor": {
    name: "Gritz Manor",
    description: `Gritz Manor stands isolated on a rocky promontory overlooking the Mistral Valley. This imposing stone structure was once home to the wealthy Gritz family, known for their collection of magical artifacts and rumored dealings with otherworldly entities. You reach Gritz Manor by travelling through the winding paths of the valley.`
  },
  "open-world": {
    name: "Open World",
    description: `The world sprawls in all directions with no clear path, only endless opportunity. Rolling hills give way to distant mountains veiled in mist, and ancient forests whisper secrets few dare to uncover. Rivers cut through the land like veins, leading to forgotten ruins, bustling trade routes, and wild, lawless frontiers. Each horizon beckons with the promise of adventure—be it treasure, mystery, or danger. In this open world, every choice carries weight, and the map is written as the players carve their story into the land itself.`
  }
};

export const INTERACTION_THRESHOLDS = {
  IMAGE_GENERATION: 5,
  ARRIVAL_COUNT: 15
};

export const API_CONFIG = {
  IMAGE_MODEL: "imagen-3.0-generate-002",
  TEXT_MODEL: "gemini-2.5-flash-preview-05-20"
};